import React, { useEffect, useState } from 'react';
import { Navbar, Container, Button, Card, Form, Collapse } from 'react-bootstrap';
import { 
    useLazyGetSummariesQuery,
    useLazyGetRandomSummariesQuery,
    useLazyGetPostGresTablesQuery,
    useLazyGetModelImagePGQuery,
    useLazyGetUserDataQuery,
    useLazyGetPostGresTableDescriptionQuery,
    useLazyGetRawRandomSummariesQuery,
    useLazyGetCheckScheduleQuery
} from '../../app/api';


export default function Advanced(){
    const [getLocalSummaries] = useLazyGetSummariesQuery();
    const [getRandomSummaries] = useLazyGetRandomSummariesQuery();
    const [getPostGresTables] = useLazyGetPostGresTablesQuery();
    const [getModelImagePG] = useLazyGetModelImagePGQuery();
    const [getUserData] = useLazyGetUserDataQuery();
    const [getPGTableDesc] = useLazyGetPostGresTableDescriptionQuery();
    const [getRawRandSummaries] = useLazyGetRawRandomSummariesQuery();
    const [getCheckSchedule] = useLazyGetCheckScheduleQuery();
    const apiHandlers = {
        localsummaries: getLocalSummaries,
        randomsummaries: getRandomSummaries,
        userdata: getUserData,
        postgrestables: getPostGresTables,
        modelimage: getModelImagePG,
        pgTableDesc: getPGTableDesc,
        rawrandsummaries: getRawRandSummaries,
        checkschedule: getCheckSchedule
    };

    const [showReturn, setShowReturn] = useState(false);
    const [gettingReturn, setGettingReturn] = useState(false);
    const [jsonData, setJsonData] = useState(null);

    // Object to store input values for each API call
    const [inputValues, setInputValues] = useState({
        localsummaries: '',
        randomsummaries: 5,
        userdata: '',
        postgrestables: '',
        modelimage: '',
        camsphotos: '',
        pgTableDesc: '',
        rawrandsummaries: 5,
        checkschedule: ''
    });

    // Track collapsed state for each card
    const [collapsedStates, setCollapsedStates] = useState({
        tokenManagement: true,
        localMySQL: false,
        remotePostgreSQL: true,
        remoteMySQL: true
    });

    // Track loading state for each individual API call
    const [loadingStates, setLoadingStates] = useState({
        localsummaries: false,
        randomsummaries: false,
        memberprofile: false,
        userdata: false,
        postgrestables: false,
        modelimage: false,
        camsphotos: false,
        pgTableDesc: false,
        rawrandsummaries: false,
        checkschedule: false
    });

    useEffect(() => {
        if(jsonData){
            setShowReturn(true);
        } else {
            setShowReturn(false);
        }
    }, [jsonData]);

    // Handle input changes
    const handleInputChange = (type, value) => {
        setInputValues(prev => ({
            ...prev,
            [type]: value
        }));
    };

    // Toggle collapsed state for a card
    const toggleCollapse = (cardName) => {
        setCollapsedStates(prev => ({
            ...prev,
            [cardName]: !prev[cardName]
        }));
    };

    const handleGetData = async (type) => {
        setJsonData(null);
        setGettingReturn(true);
        
        // Set loading state for this specific API call
        setLoadingStates(prev => ({
            ...prev,
            [type]: true
        }));

        if(!apiHandlers[type]){
            setGettingReturn(false);
            setLoadingStates(prev => ({
                ...prev,
                [type]: false
            }));
            return;
        }

        const keys = {
            modelimage: "id",
            userdata: "id",
            pgTableDesc: "table",
            randomsummaries: "limit",
            rawrandsummaries: "limit"
        };
        const pkg = {};
        pkg[keys[type]] = inputValues[type];

        try {
            // Pass the input value to the API call
            const res = await apiHandlers[type](pkg);
            if (res.isSuccess) {
                console.log(type, res.data);
                setJsonData(JSON.stringify(res.data, null, 2));
            } else {
                console.error(type, res);
                setJsonData(JSON.stringify({"ERROR": "Failed to fetch data. See console for details."}, null, 2));
            }
        } catch (error) {
            console.error("API call failed:", error);
            setJsonData(JSON.stringify({"ERROR": "An unexpected error occurred"}, null, 2));
        } finally {
            setGettingReturn(false);
            // Reset loading state for this specific API call
            setLoadingStates(prev => ({
                ...prev,
                [type]: false
            }));
        }
    }

    return (
        <div>
            <Navbar bg="light" expand="lg">
                <Container>
                    <Navbar.Brand href="#">
                        <div className="logo-wrapper">
                            <span className="logo-text">Advanced Dev Tools</span>
                        </div>
                    </Navbar.Brand>
                </Container>
            </Navbar>
            <Container className='mt-3'>
                <Card className="mb-3">
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <span>Token Management</span>
                        <Button 
                            variant="outline-secondary" 
                            size="sm"
                            onClick={() => toggleCollapse('tokenManagement')}
                        >
                            {collapsedStates.tokenManagement ? 'Expand' : 'Collapse'}
                        </Button>
                    </Card.Header>
                    <Collapse in={!collapsedStates.tokenManagement}>
                        <div>
                            <Card.Body>
                                <Button
                                    variant="danger"
                                    onClick={()=>{ localStorage.removeItem('chamaileon_access_token'); alert('Token deleted from local storage!') }}>
                                    Delete API Token
                                </Button>
                            </Card.Body>
                        </div>
                    </Collapse>
                </Card>

                <Card className="mb-3">
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <span>Local MySQL Operations</span>
                        <Button 
                            variant="outline-secondary" 
                            size="sm"
                            onClick={() => toggleCollapse('localMySQL')}
                        >
                            {collapsedStates.localMySQL ? 'Expand' : 'Collapse'}
                        </Button>
                    </Card.Header>
                    <Collapse in={!collapsedStates.localMySQL}>
                        <div>
                            <Card.Body>
                                <div className="mb-4">
                                    <Form.Group className="text-start">
                                        <Form.Label>checkschedule Parameters</Form.Label>
                                        <Form.Control
                                            className="mb-2"
                                            disabled
                                            style={{ width: '600px' }}
                                            placeholder="DISABLED"
                                            value={inputValues.checkschedule}
                                            onChange={(e) => handleInputChange('checkschedule', e.target.value)}
                                        />
                                        <Button
                                            variant="primary"
                                            disabled={loadingStates.checkschedule}
                                            onClick={() => handleGetData('checkschedule')}>
                                            Get checkschedule from Local MySQL
                                            {loadingStates.checkschedule && 
                                                <img src="../images/loader.gif" width={20} className="ms-2" alt="Loading..." />
                                            }
                                        </Button>
                                    </Form.Group>
                                </div>
                            </Card.Body>
                        </div>
                    </Collapse>
                </Card>

                <Card className="mb-3">
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <span>Remote PostgreSQL Operations</span>
                        <Button 
                            variant="outline-secondary" 
                            size="sm"
                            onClick={() => toggleCollapse('remotePostgreSQL')}
                        >
                            {collapsedStates.remotePostgreSQL ? 'Expand' : 'Collapse'}
                        </Button>
                    </Card.Header>
                    <Collapse in={!collapsedStates.remotePostgreSQL}>
                        <div>
                            <Card.Body>
                                <div className="mb-4">
                                    <Form.Group className="text-start">
                                        <Form.Label style={{fontSize: '12px'}}>Amount to Retrieve</Form.Label>
                                        <Form.Control
                                            className="mb-2"
                                            style={{ width: '200px' }}
                                            value={inputValues.randomsummaries}
                                            onChange={(e) => handleInputChange('randomsummaries', e.target.value)}
                                        />
                                        <Button
                                            variant="primary"
                                            disabled={loadingStates.randomsummaries}
                                            onClick={() => handleGetData('randomsummaries')}>
                                            Get PARSED Random Summaries from Remote Postgres Server
                                            {loadingStates.randomsummaries && 
                                                <img src="../images/loader.gif" width={20} className="ms-2" alt="Loading..." />
                                            }
                                        </Button>
                                    </Form.Group>
                                </div>

                                <div className="mb-4">
                                    <Form.Group className="text-start">
                                        <Form.Label style={{fontSize: '12px'}}>Amount to Retrieve</Form.Label>
                                        <Form.Control
                                            className="mb-2"
                                            style={{ width: '200px' }}
                                            value={inputValues.rawrandsummaries}
                                            onChange={(e) => handleInputChange('rawrandsummaries', e.target.value)}
                                        />
                                        <Button
                                            variant="primary"
                                            disabled={loadingStates.rawrandsummaries}
                                            onClick={() => handleGetData('rawrandsummaries')}>
                                            Get RAW Random Summaries from Remote Postgres Server
                                            {loadingStates.rawrandsummaries && 
                                                <img src="../images/loader.gif" width={20} className="ms-2" alt="Loading..." />
                                            }
                                        </Button>
                                    </Form.Group>
                                </div>

                                
                            </Card.Body>
                        </div>
                    </Collapse>
                </Card>

                <Card className="mb-3">
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <span>Additional Remote DB Operations</span>
                        <Button 
                            variant="outline-secondary" 
                            size="sm"
                            onClick={() => toggleCollapse('remoteMySQL')}
                        >
                            {collapsedStates.remoteMySQL ? 'Expand' : 'Collapse'}
                        </Button>
                    </Card.Header>
                    <Collapse in={!collapsedStates.remoteMySQL}>
                        <div>
                            <Card.Body>
                                <div className="mb-4">
                                    <Form.Group className="text-start">
                                        <Form.Label>User Data</Form.Label>
                                        <Form.Control
                                            className="mb-2"
                                            style={{ width: '600px' }}
                                            placeholder="Enter user id"
                                            value={inputValues.userdata}
                                            onChange={(e) => handleInputChange('userdata', e.target.value)}
                                        />
                                        <Button
                                            variant="primary"
                                            disabled={loadingStates.userdata}
                                            onClick={() => handleGetData('userdata')}>
                                            Get User Data from Remote Postgres Server
                                            {loadingStates.userdata && 
                                                <img src="../images/loader.gif" width={20} className="ms-2" alt="Loading..." />
                                            }
                                        </Button>
                                    </Form.Group>
                                </div>

                                <div className="mb-4">
                                    <Form.Group className="text-start">
                                        <Form.Label>Model Image</Form.Label>
                                        <Form.Control
                                            className="mb-2"
                                            style={{ width: '600px' }}
                                            placeholder="Enter model ID"
                                            value={inputValues.modelimage}
                                            onChange={(e) => handleInputChange('modelimage', e.target.value)}
                                        />
                                        <Button
                                            variant="primary"
                                            disabled={loadingStates.modelimage}
                                            onClick={() => handleGetData('modelimage')}>
                                            Get Model Image
                                            {loadingStates.modelimage && 
                                                <img src="../images/loader.gif" width={20} className="ms-2" alt="Loading..." />
                                            }
                                        </Button>
                                    </Form.Group>
                                </div>

                                <div className="mb-4">
                                    <Form.Group className="text-start">
                                        <Form.Label>Describe Postgres Table</Form.Label>
                                        <Form.Control
                                            className="mb-2"
                                            style={{ width: '600px' }}
                                            placeholder="Table Name"
                                            value={inputValues.pgTableDesc}
                                            onChange={(e) => handleInputChange('pgTableDesc', e.target.value)}
                                        />
                                        <Button
                                            variant="primary"
                                            disabled={loadingStates.pgTableDesc}
                                            onClick={() => handleGetData('pgTableDesc')}>
                                            Get Table Description
                                            {loadingStates.pgTableDesc && 
                                                <img src="../images/loader.gif" width={20} className="ms-2" alt="Loading..." />
                                            }
                                        </Button>
                                    </Form.Group>
                                </div>

                                <div className="mb-4">
                                    <Form.Group className="text-start">
                                        <Form.Label>Postgres Tables</Form.Label>
                                        <Form.Control
                                            className="mb-2"
                                            disabled
                                            style={{ width: '600px' }}
                                            placeholder="DISABLED"
                                            value={inputValues.postgrestables}
                                            onChange={(e) => handleInputChange('postgrestables', e.target.value)}
                                        />
                                        <Button
                                            variant="primary"
                                            disabled={loadingStates.postgrestables}
                                            onClick={() => handleGetData('postgrestables')}>
                                            Get All Postgres Tables
                                            {loadingStates.postgrestables && 
                                                <img src="../images/loader.gif" width={20} className="ms-2" alt="Loading..." />
                                            }
                                        </Button>
                                    </Form.Group>
                                </div>
                                <div className="mb-4">
                                    <Form.Group className="text-start">
                                        <Form.Label>Cams Photo Data</Form.Label>
                                        <Form.Control
                                            className="mb-2"
                                            style={{ width: '600px' }}
                                            placeholder="Enter photo ID or username"
                                            value={inputValues.camsphotos}
                                            onChange={(e) => handleInputChange('camsphotos', e.target.value)}
                                        />
                                        <Button
                                            variant="primary"
                                            disabled={loadingStates.camsphotos}
                                            onClick={() => { 
                                                console.log('pressed', inputValues.camsphotos);
                                                // Set this loader just for consistency
                                                setLoadingStates(prev => ({
                                                    ...prev,
                                                    camsphotos: true
                                                }));
                                                // Simulate an API call for demo purposes
                                                setTimeout(() => {
                                                    setLoadingStates(prev => ({
                                                        ...prev,
                                                        camsphotos: false
                                                    }));
                                                }, 1500);
                                            }}>
                                            Get Cams Photo Data from Remote MySQL Server
                                            {loadingStates.camsphotos && 
                                                <img src="../images/loader.gif" width={20} className="ms-2" alt="Loading..." />
                                            }
                                        </Button>
                                    </Form.Group>
                                </div>
                            </Card.Body>
                        </div>
                    </Collapse>
                </Card>
            </Container>

            <Container>
                {gettingReturn && 
                    <p className='m-3'>
                        <img src="../images/loader.gif" width={50}/>
                        <span className='mx-3'>LOADING DATA ...</span>
                    </p>
                }
                {showReturn && 
                    <div className="codeView">
                        <pre>{jsonData}</pre>
                    </div>
                }
            </Container>
        </div>
    )
}